;(function ($) {
	var body = $('body')
	var wh = $(window).height()
	var headerh = $('#header').outerHeight()
	var footerh = $('#footer').outerHeight()

	$('#bd').css('min-height', wh - headerh - footerh)

	// Search form
	$('a[href="#search"]').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var panel = $('.searchform')
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		// body.toggleClass('menu-main-open')
		panel.toggleClass('visible')
		$this.attr('aria-expanded', expandend)
		panel.attr('aria-expanded', expandend)
		panel.attr('aria-hidden', hidden)
		if (body.hasClass('menu-main-open')) {
			$('.nav-primary__toggle').trigger('click')
		}
	})

	// Auto-scroll for Intro
	// function pageScroll(to) {
	// 	var from = $(window).scrollTop()
	// 	if (from < to) {
	// 		$('html, body').animate({ scrollTop: to - 90 }, (to - from) / 0.05, 'linear')
	// 	}
	// }
	// function stopScroll() {
	// 	$('html, body').stop()
	// }
	// if (body.hasClass('page-template-intro')) {
	// 	var bottomIntro = $('.accordeon').eq(0).offset().top
	// 	pageScroll(bottomIntro)
	// 	body.on('mousewheel', function () {
	// 		stopScroll()
	// 		clearTimeout($.data(this, 'timer'))
	// 		$.data(
	// 			this,
	// 			'timer',
	// 			setTimeout(function () {
	// 				pageScroll(bottomIntro)
	// 			}, 250)
	// 		)
	// 	})
	// }

	// Accordeon - atoclose opened one
	$('.accordeon__toggle').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var parent = $this.parent()
		var panel = parent.find('.accordeon__panel')
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		if (parent.hasClass('accoredon-opened')) {
			panel.slideUp().attr('aria-expanded', expandend).attr('aria-hidden', hidden)
			$this.attr('aria-expanded', expandend)
			parent.removeClass('accoredon-opened')
			// window.location.hash = ''
		} else {
			// var opened = $('.accordeon.accoredon-opened')
			// opened.find('.accordeon__toggle').attr('aria-expanded', 'false')
			// opened.find('.accordeon__panel').attr('aria-expanded', 'false').attr('aria-hidden', 'true').slideUp()
			// opened.removeClass('accoredon-opened')
			panel.slideDown().attr('aria-expanded', expandend).attr('aria-hidden', hidden)
			$this.attr('aria-expanded', expandend)
			parent.addClass('accoredon-opened')
			// window.location.hash = parent.attr('id')
			$('html, body').animate({ scrollTop: $($this).offset().top - 70 }, 500)
		}
	})

	// Readmore
	$('.readmore__toggle').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var parent = $this.parent()
		var panel = parent.find('.readmore__panel')
		var currentLabel = $this.html()
		var icon = parent.attr('data-icon') === '+' ? '-' : '+'
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		panel.slideToggle().attr('aria-expanded', expandend).attr('aria-hidden', hidden)
		$this.html($this.attr('data-label')).attr('data-label', currentLabel).attr('aria-expanded', expandend)
		parent.attr('data-icon', icon)
	})

	// Page Index
	$('.page-index__toggle').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var index = $this.parent()
		var panel = index.find('.page-index__panel')
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		index.toggleClass('opened')
		panel.attr('aria-expanded', expandend).attr('aria-hidden', hidden)
		$this.attr('aria-expanded', expandend)
	})

	$('#page-index a').on('click', function (e) {
		e.preventDefault()
		var target = $(this).attr('href')
		$('html, body').animate({ scrollTop: $(target).offset().top - 70 }, 750)
	})

	// Video hover play
	$('.home__slide--video').on('mouseenter', function () {
		$(this).find('video').get(0).play()
	})
	$('.home__slide--video').on('mouseleave', function () {
		$(this).find('video').get(0).pause()
	})

	// Menu Filters
	$('.terms-nav__item-has-children > a').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var parent = $this.parent()
		var panel = parent.find('.terms-nav__sub')
		if (parent.hasClass('terms-nav__item--opened')) {
			panel.slideUp().attr('aria-expanded', 'false').attr('aria-hidden', 'true')
			parent.attr('aria-expanded', 'false').removeClass('terms-nav__item--opened')
		} else {
			var opened = $('.terms-nav__item--opened')
			opened.attr('aria-expanded', 'false')
			opened.find('.terms-nav__sub').attr('aria-expanded', 'false').attr('aria-hidden', 'true').slideUp()
			opened.removeClass('terms-nav__item--opened')
			panel.slideDown().attr('aria-expanded', 'true').attr('aria-hidden', 'false')
			parent.attr('aria-expanded', 'true').addClass('terms-nav__item--opened')
		}
	})

	// Pop-up
	$('a.popup__open').on('click', function (e) {
		e.preventDefault()
		$(this).attr('aria-expandend', 'true')
		$($(this).attr('href')).addClass('visible').attr('aria-expanded', 'true').attr('aria-hidden', 'false')
	})

	$('.popup__close').on('click', function (e) {
		e.preventDefault()
		var ele = $(this).parent().parent()
		ele.removeClass('visible').attr('aria-expanded', 'false').attr('aria-hidden', 'true')
		$('a[href="#' + ele.attr('id') + '"]').attr('aria-expandend', 'false')
		$('#newsletter')
	})

	$('a[href="#cookies"]').on('click', function (e) {
		e.preventDefault()
		// console.log('click')
		$('button.cc-revoke').trigger('click')
	})

	/**
	 * Complianz
	 */
	$('.manage-cookies-custom-link a').on('click', function (e) {
		e.preventDefault()
		$('#cmplz-manage-consent .cmplz-manage-consent').trigger('click')
	})
})(jQuery)
